<template>
  <v-radio-group v-model="paymentOption" :mandatory="false">
    <div
      style="min-height: 76px; max-height: 76px;"
      class="radio-option pt-0"
      @click="paymentOption = option.id"
      :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
    >
      <v-layout class="radio-option__info">
        <v-flex>
          <v-layout row align-center>
            <v-icon color="primary" class="mr-3">las la-dollar-sign</v-icon>
            <div class="radio-option__info-text">
              <label :for="option.id">{{ option.label }}</label>
            </div>
          </v-layout>
        </v-flex>
        <v-flex shrink>
          <v-radio
            style="margin-right: 6px;"
            color="primary"
            :id="option.id"
            :value="option.id"
          ></v-radio>
        </v-flex>
      </v-layout>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  data() {
    return {
      option: {
        id: 'INVOICE',
        label: 'Venda Faturada',
      },
    };
  },
  computed: {
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentBillet.styl';
</style>
